<script setup lang="ts">
defineProps({
	isOpen: {
		type: Boolean,
		default: false,
		required: true,
	},
});

defineEmits<{
	(e: 'onClose'): void;
}>();
</script>

<template>
	<BaseSideDrawer
		class="menu-sidebar"
		:is-open="isOpen"
		@on-close="$emit('onClose')"
	>
		<template #header>
			<div class="form-header">
				<RouterLink
					:to="ROUTE.INDEX.PATH"
					@click="$emit('onClose')"
				>
					<Logo />
				</RouterLink>
			</div>
		</template>
		<template #content>
			<slot />
		</template>
	</BaseSideDrawer>
</template>

<style scoped lang="scss">
.menu-sidebar {
	@include fonts-get(semibold, text-md);
	color: colors-get(gray, 600);

	:deep(.drawer-title) {
		padding: spacings-get(4);
		height: rem(80);
	}

	:deep(.drawer-content) {
		padding: spacings-get(6) 0;
	}

	.menu-list {
		color: colors-get(gray, 600);

		:deep(.v-list-item--active) {
			background-color: unset;
		}

		:deep(.v-list-item):hover {
			background-color: colors-get(gray, 50);
		}
	}
}
</style>
